// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"80af1446","239":"0010d51f","455":"1b8b1d52","940":"8385ab52"}[chunkId] + ".chunk.js";
};